import { PLATE_FEATHER } from 'features/ui';

/** Shell frame padding/gap — the rail overlay's offsets must match it. */
export const SHELL_GAP = 18;

/** Corner radius of the dock card and bottom sheets. */
export const SHELL_RADIUS = 18;

/** Shell page gutters, horizontal only — the pages that own their own
 *  vertical layout share them so their content aligns with `PageBody`. From
 *  `md` up the scroll container pads by `SHELL_GAP` on the left
 *  (`scrollInsetSx`), so the left gutter drops to zero; the right gutter
 *  stays for scrollbar clearance. */
export const pageGutterX = {
  pl: { xs: 2, md: 0 },
  pr: { xs: 2, md: 3 },
} as const;

/** Padding inside the `#main-content` scroll container: the dock/rail spacing
 *  on the left from `md` up, and room for the plates' feather at the top. A
 *  scroll container clips at its padding edge, so plated text and card
 *  shadows need this room inside the box. `PageHeader`, which sits above the
 *  container, pads by the same left amount to stay aligned. */
export const scrollInsetSx = {
  pl: { md: `${String(SHELL_GAP)}px` },
  pt: `${String(PLATE_FEATHER)}px`,
} as const;

/** The full `PageBody` gutters: the horizontal ones plus the bottom spacing. */
export const pageGutterSx = {
  ...pageGutterX,
  pb: 3,
} as const;

/** Widest the desktop content grid grows, header included. */
export const CONTENT_MAX_WIDTH = 1108;

/** Gap between the desktop content columns, in theme spacing units. */
export const CONTENT_GAP = 3;

/** Home's reserved right-hand column. */
export const SIDE_COLUMN_WIDTH = 360;

/** Schedule's month-calendar column. */
export const CALENDAR_COLUMN_WIDTH = 384;
